<template>
  <div class="single-upload upload-container">
    <el-upload
      class="upload-demo"
      ref="upload"
      action="#"
      :limit="1"
      :on-exceed="handleExceed"
      :before-upload="beforeUpload"
      :http-request="customUpload"
      :on-remove="handleRemove"
      :on-change="handleChange"
      :file-list="fileList"
      :show-file-list="false"
      :auto-upload="false"
    >
      <el-button
        slot="trigger"
        size="medium"
        type="primary"
        icon="el-icon-folder-opened"
        >选择文件</el-button
      >
      <!-- <div slot="tip" class="el-upload__tip">
        只能上传类型为 doc/docx/xls/xlsx/pdf 文件。
      </div> -->
    </el-upload>
    <div v-if="currentFile" class="file-name">
      <div class="file-info">
        <i class="el-icon-document"></i> {{ currentFile.name }} ({{
          formatFileSize(currentFile.size)
        }})
      </div>
      <div class="file-action">
        <i class="el-icon-delete" @click="handleRemoveFile"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SingleUpload",
  data() {
    return {
      fileList: [],
      currentFile: null
    };
  },
  methods: {
    // 自定义上传方法
    customUpload(options) {},

    // 提交上传
    submitUpload() {
      if (!this.currentFile) {
        this.$message.warning("请先选择文件");
        return false;
      }
      return this.fileList;
      //自定义上传方法
      // this.$refs.upload.submit();
    },

    // 文件状态改变时的钩子
    handleChange(file, fileList) {
      this.fileList = fileList;
      this.currentFile = file.raw;
    },

    // 文件超出数量限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning("只能上传一个文件，请先删除当前文件后再选择新文件");
    },

    // 上传前的校验
    beforeUpload(file) {
      this.currentFile = file;
      // 检查文件类型
      const allowedTypes = ["doc", "docx", "xls", "xlsx", "pdf"];
      const fileExtension = file.name
        .split(".")
        .pop()
        .toLowerCase();
      const isAllowedType = allowedTypes.includes(fileExtension);

      if (!isAllowedType) {
        this.$message.warning(
          "文件格式不正确，请上传 doc/docx/xls/xlsx/pdf 格式的文件"
        );
        return false;
      }

      // 检查文件大小 (100MB)
      // const isLt100M = file.size / 1024 / 1024 < 100;
      // if (!isLt100M) {
      //   this.$message.warning("文件大小不能超过 100MB");
      //   return false;
      // }

      return true;
    },

    // 文件移除时的处理
    handleRemove(file, fileList) {
      this.currentFile = null;
    },
    handleRemoveFile() {
      this.currentFile = null;
      this.fileList = [];
    },
    // 格式化文件大小显示
    formatFileSize(size) {
      if (size < 1024) {
        return size + " B";
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + " KB";
      } else if (size < 1024 * 1024 * 1024) {
        return (size / (1024 * 1024)).toFixed(2) + " MB";
      } else {
        return (size / (1024 * 1024 * 1024)).toFixed(2) + " GB";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.upload-container {
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.upload-demo {
  text-align: center;
}
.el-upload__tip {
  margin-top: 10px;
  color: #909399;
  font-size: 14px;
}

.file-name {
  margin-top: 10px;
  padding: 5px 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  display: grid;
  grid-template-columns: 1fr 20px;
  align-items: start;
  gap: 20px;
  .file-action {
    cursor: pointer;
    &:hover {
      color: #ff6c66;
    }
  }
}
</style>
